export const filterNullable = <T>(arr: (T| null)[]): T[] => {
    const nnArr = [];
    for(const elem of arr) {
        if(elem != null) nnArr.push(elem);
    }
    return nnArr;
}